module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-4k-3be0700d.svg";